// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__21VQc","header":"Messages_header__h_XlC"};